import React, { useState } from 'react';
import Login from './Login';
import SignUp from './SignUp';
import ForgotPassword from './ForgotPassword';

const AuthContainer = () => {
    const [currentView, setCurrentView] = useState('login'); // 'login', 'signup', 'forgot'

    const switchToLogin = () => setCurrentView('login');
    const switchToSignup = () => setCurrentView('signup');
    const switchToForgotPassword = () => setCurrentView('forgot');

    const renderCurrentView = () => {
        switch (currentView) {
            case 'signup':
                return (
                    <SignUp 
                        onSwitchToLogin={switchToLogin}
                    />
                );
            case 'forgot':
                return (
                    <ForgotPassword 
                        onSwitchToLogin={switchToLogin}
                    />
                );
            case 'login':
            default:
                return (
                    <Login 
                        onSwitchToSignup={switchToSignup}
                        onSwitchToForgotPassword={switchToForgotPassword}
                    />
                );
        }
    };

    return renderCurrentView();
};

export default AuthContainer; 